/**
 * JS mirror of Ppk2\Profile\Club\ClubRules (src/Club/ClubRules.php), kept
 * IDENTICAL for instant feedback. The server always re-checks (and also
 * checks that the domain is not taken).
 *
 * The club name IS the domain of its forum, second or third level, without
 * https:// and without a path: pp2forum.ru, club.pp2forum.ru.
 */
export const MAX_LENGTH = 100;
export const LABEL_MAX = 63;
export const MIN_LEVELS = 2;
export const MAX_LEVELS = 3;
export const ROLES = ['player', 'referee', 'hoster', 'moderator', 'admin'];
export const DEFAULT_ROLE = 'player';
export const KEY = 'ppk2-profile.lib.club.';
const LABEL = /^[\p{L}\p{M}\p{N}](?:[\p{L}\p{M}\p{N}-]*[\p{L}\p{M}\p{N}])?$/u;
const TLD = /^(?:[\p{L}\p{M}]{2,}|xn--[a-z0-9-]+)$/u;

/** trim, drop http(s)://, then leading www. (repeated too), drop trailing «/» (one or several), lowercase everything. */
export function normalize(value) {
  if (typeof value !== 'string') return null;
  const v = value.replace(/^[\s\p{Z}]+|[\s\p{Z}]+$/gu, '').replace(/^https?:\/\//i, '').replace(/^(?:www\.)+/i, '').replace(/\/+$/, '').toLowerCase();
  return v === '' ? null : v;
}
export function validHost(host) {
  const labels = host.split('.');
  for (const l of labels) {
    if (l === '' || Array.from(l).length > LABEL_MAX || !LABEL.test(l)) return false;
  }
  return TLD.test(labels[labels.length - 1]);
}

/** @returns {[string, object]|null} */
export function check(address) {
  if (address === null) return [KEY + 'address_required', {}];
  if (Array.from(address).length > MAX_LENGTH) return [KEY + 'address_too_long', {
    max: MAX_LENGTH
  }];
  if (/[\s\p{Z}]/u.test(address)) return [KEY + 'address_space', {}];
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(address)) return [KEY + 'address_scheme', {}];
  if (/[/?#]/.test(address)) return [KEY + 'address_path', {}];
  const levels = address.split('.').length;
  if (levels < MIN_LEVELS || levels > MAX_LEVELS) return [KEY + 'address_levels', {}];
  if (!validHost(address)) return [KEY + 'address_host', {}];
  return null;
}
export function forumUrl(address) {
  return 'https://' + address;
}
flarum.reg.add('ppk2-profile', 'forum/utils/clubRules', { MAX_LENGTH: MAX_LENGTH,LABEL_MAX: LABEL_MAX,MIN_LEVELS: MIN_LEVELS,MAX_LEVELS: MAX_LEVELS,ROLES: ROLES,DEFAULT_ROLE: DEFAULT_ROLE,KEY: KEY,normalize: normalize,validHost: validHost,check: check,forumUrl: forumUrl, });